import * as runtime from '@/api/runtime'
import {
  AdvancementStudent,
  AdvancementStudentFromJSON,
  BatchSchoolStatisticsAdvancementRequest,
  BatchSchoolStatisticsAdvancementRequestToJSON,
  BatchSchoolStatisticsAdvancementStudentSearchRequest,
  BatchSchoolStatisticsAdvancementStudentSearchRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class BatchSchoolStatisticsAdvancementApi extends runtime.BaseAPI {
  async search(
    request: BatchSchoolStatisticsAdvancementStudentSearchRequest
  ): Promise<AdvancementStudent[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(
        BatchSchoolStatisticsAdvancementStudentSearchRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery
    const response = await this.requestGet(
      '/batch/school-statistics/advancement',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AdvancementStudentFromJSON)
    ).value()
  }

  /**
   * 進級設定を登録する
   * 進級登録
   */
  async advancement(
    request: BatchSchoolStatisticsAdvancementRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = BatchSchoolStatisticsAdvancementRequestToJSON(
      request
    )
    const response = await this.requestPut(
      '/batch/school-statistics/advancement',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
